import axios from 'src/utils/axios';

export const GET_ACTION_LOGS = '@chat/get-action-logs';

export const GET_CONTACTS = '@chat/get-contacts';
export const GET_TEMPLATES = '@chat/get-templates';

export const GET_THREADS = '@chat/get-threads';
export const GET_THREAD = '@chat/get-thread';
export const ADD_THREAD = '@chat/add-thread';
export const MARK_THREAD_AS_SEEN = '@chat/mark-thread-as-seen';
export const PAUSE_THREAD = '@chat/pause';
export const PAUSE_THREAD_OPTIMISTIC = '@chat/pause-thread-optimistic';
export const PAUSE_THREAD_REVERT = '@chat/pause-thread-revert';

export const GET_MESSAGES = '@chat/get-messages';
export const ADD_MESSAGE = '@chat/add-message';
export const UPDATE_MESSAGE = '@chat/update-message';
export const UPDATE_MESSAGES = '@chat/update-messages';
export const CREATE_MESSAGE = '@chat/create-message';
export const OPEN_SIDEBAR = '@chat/open-sidebar';
export const CLOSE_SIDEBAR = '@chat/close-sidebar';

export const GET_HANDOFFS = '@chat/get-handoffs';
export const GET_HANDOFFS_PAGINATED = '@chat/get-handoffs-paginated';
export const UPDATE_HANDOFF = '@chat/update-handoff';
export const ADD_HANDOFF_PAUSE_THREAD = '@chat/add-handoff-pause-thread';
export const RESOLVE_HANDOFF = '@chat/resolve-handoff';
export const ADD_HANDOFF = '@chat/add-handoff';
export const UNREAD_COUNT = '@chat/unread-count';
export const SET_SORT = '@chat/set-sort';
export const SET_SUPPORT_SORT = '@chat/set-support-sort';

export const GET_HANDOFF_COMMENTS = '@chat/get-handoffs-comments';
export const GET_THREAD_COMMENTS = '@chat/get-thread-comments';
export const UPDATE_HANDOFF_COMMENTS = '@chat/update-handoff-comments';
export const ADD_HANDOFF_COMMENTS = '@chat/add-handoff-comments';
export const DELETE_HANDOFF_COMMENTS = '@chat/delete-handoff-comments';

//contacts
export function getContacts(botId) {
  const request = axios.get(`/api/human-help/${botId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_CONTACTS,
        payload: response.data
      })
    );
  };
}
//templates
export function getTemplates(botId) {
  const request = axios.get(`/api/server/templates/${botId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_TEMPLATES,
        payload: response.data
      })
    );
  };
}

//threads
export function getThreads(botId) {
  const request = axios.get(`/api/threads/all-active/${botId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_THREADS,
        payload: response.data
      })
    );
  };
}
export function getThread(thread_id, botId) {
  const request = axios.post(`/api/threads/get/${botId}`, {
    thread_id
  });

  return dispatch => {
    return request.then(response => {
      dispatch({
        type: GET_THREAD,
        payload: response.data
      });
      return response.data;
    });
  };
}
export function markThreadAsSeen(payload, botId) {
  const request = axios.post(`/api/threads/mark-as-seen/${botId}`, payload);

  return dispatch => {
    request.then(() =>
      dispatch({
        type: MARK_THREAD_AS_SEEN,
        payload: {
          thread_id: payload.thread_id
        }
      })
    );
  };
}
export function pauseConversation(thread, botId) {
  const request = axios.post(`/api/threads/pause/${botId}`, {
    thread_id: thread.id,
    channel: thread.channel,
    user_id: thread.user_id
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: PAUSE_THREAD,
        payload: {
          thread_id: thread.id
        }
      })
    );
  };
}

//messages
export function getMessages(threadId) {
  const request = axios.get(`/api/messages/all/${threadId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_MESSAGES,
        payload: {
          threadId,
          messages: response.data
        }
      })
    );
  };
}

export function updateMessages(threadId, offset) {
  const request = axios.get(`/api/messages/all/${threadId}?offset=${offset}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_MESSAGES,
        payload: {
          threadId,
          messages: response.data
        }
      })
    );
  };
}

export function addMessage({ threadId, senderId, payload }) {
  const request = axios.post(`/api/messages/new`, {
    threadId,
    senderId,
    payload
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: CREATE_MESSAGE,
        payload: response.data
      })
    );
  };
}

export async function addMediaMessage({ threadId, senderId, mediaFile }) {
  let formData = new FormData();
  formData.append('media', mediaFile);
  formData.append('threadId', threadId);
  formData.append('senderId', senderId);

  const { data } = await axios.post('/api/messages/media', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return data;
}
//sidebar
export function openSidebar() {
  return {
    type: OPEN_SIDEBAR
  };
}

export function closeSidebar() {
  return {
    type: CLOSE_SIDEBAR
  };
}
export function setSort(sort) {
  return {
    type: SET_SORT,
    payload: { sort }
  };
}
export function setSupportSort(sort) {
  return {
    type: SET_SUPPORT_SORT,
    payload: { sort }
  };
}
//handoff
export function getHandoffs(botId) {
  const request = axios.get(`/api/handoff/all/${botId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_HANDOFFS,
        payload: response.data
      })
    );
  };
}

/**
 * Fetch a single page of handoffs from the server with filters, search, sort, and pagination.
 * Used exclusively by the support ChatView sidebar (HandoffList).
 *
 * @param {string} botId
 * @param {{ page, limit, sort, search, filters, assignee_me, stagnant_minutes }} params
 */
export function getHandoffsPaginated(botId, params = {}) {
  const {
    page = 0,
    limit = 10,
    sort = 'last_seen|desc',
    search = '',
    leadId,
    filters = [],
    channels = [],
    tags = [],
    assignee_me,
    stagnant_minutes
  } = params;

  // Build query string
  const query = new URLSearchParams();
  query.set('page', page);
  query.set('limit', limit);
  query.set('sort', sort);
  if (search) query.set('search', search);
  if (leadId) query.set('leadId', leadId);
  if (assignee_me) query.set('assignee_me', assignee_me);
  if (stagnant_minutes != null) query.set('stagnant_minutes', stagnant_minutes);
  filters.forEach(f => query.append('filters[]', f));
  channels.forEach(f => query.append('channels[]', f));
  tags.forEach(f => query.append('tags[]', f));

  const request = axios.get(`/api/handoff/paginated/${botId}?${query.toString()}`);

  return dispatch => {
    return request.then(response => {
      dispatch({
        type: GET_HANDOFFS_PAGINATED,
        payload: response.data // { handoffs, threads, total }
      });

      return response.data;
    });
  };
}

export function updateHandoff(handoff) {
  const request = axios.put(`/api/handoff/update`, {
    handoff
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: UPDATE_HANDOFF,
        payload: {
          handoff
        }
      })
    );
  };
}

export function addHandoffPauseThread(thread, botId) {
  const request = axios.post(`/api/handoff/addandPause/${botId}`, {
    thread
  });

  return dispatch => {
    const prevThread = { ...thread };
    dispatch({
      type: PAUSE_THREAD_OPTIMISTIC,
      payload: { threadId: thread.id, prevThread }
    });

    return request
      .then(response => {
        dispatch({
          type: ADD_HANDOFF_PAUSE_THREAD,
          payload: { thread }
        });
        return response;
      })
      .catch(error => {
        dispatch({
          type: PAUSE_THREAD_REVERT,
          payload: { threadId: thread.id, prevThread }
        });
        throw error;
      });
  };
}

export function resolveHandoff(threadId, handoffId, botId) {
  const request = axios.post(`/api/handoff/resolve/${botId}`, {
    threadId,
    handoffId
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: RESOLVE_HANDOFF,
        payload: { handoff: { id: handoffId } }
      })
    );
  };
}

//handoff comments

export function getAllHandoffComments(handoffId) {
  const request = axios.get(`/api/handoff/comments/all/${handoffId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_HANDOFF_COMMENTS,
        payload: response.data
      })
    );
  };
}
export function getAllCommentsByThreadId(threadId) {
  const request = axios.get(`/api/handoff/comments/thread/${threadId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_THREAD_COMMENTS,
        payload: response.data
      })
    );
  };
}
export function addOneHandoffComments(data, threadKey) {
  const request = axios.post(`/api/handoff/comments/add`, {
    comment: data
  });
  return dispatch => {
    request.then(
      response => {
        dispatch({
          type: ADD_HANDOFF_COMMENTS,
          payload: { ...response.data, threadKey }
        });
        dispatch({
          type: '@toaster-event',
          payload: {
            message: 'Comment added',
            variant: 'success'
          }
        });
      },
      error =>
        dispatch({
          type: '@toaster-event',
          payload: {
            message: error.message || 'something went wrong',
            variant: 'error'
          }
        })
    );
  };
}
export function updateHandoffComments(data) {
  const request = axios.put(`/api/handoff/comments/update`, {
    data
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_HANDOFF_COMMENTS,
        payload: response.data
      })
    );
  };
}
export function deleteHandoffComments(commentId) {
  const request = axios.delete(`/api/handoff/comments/delete/${commentId}`);

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_HANDOFF_COMMENTS,
        payload: { id: commentId }
      })
    );
  };
}
